import { useAiSettings } from "../../../api/hooks";
import { useFeatureFlagQuery } from "../../../hooks/useFeatureFlag";

/** Whether the Form Building Coach is available: coaching FF + the company setting. */
export const useFormBuildingCoachEnabled = (): boolean => {
	const { value: aiEnabled } = useFeatureFlagQuery("ff-is-ai-enabled", false);
	const { value: coachingEnabled } = useFeatureFlagQuery("ff-is-coaching-enabled", false);

	const { data: aiSettings } = useAiSettings();
	const formBuildingCoachEnabled = aiSettings?.formBuildingCoachEnabled ?? false;

	return aiEnabled && coachingEnabled && formBuildingCoachEnabled;
};
